import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { TableOnboardingProps as Props } from './types';
import { Box, Typography } from '@mui/material';

export const TableOnboarding = memo(({ className, onboardingProps }: Props) => {
  return (
    <Styled.Wrapper
      className={classnames('TableOnboarding', className)}
      sx={SX.root}
    >
      <Typography variant="body1" fontWeight={700} color="grey.800">
        {onboardingProps?.title || 'Nothing Here Yet.'}
      </Typography>
      <Typography variant="body3" color="grey.500" fontWeight={400}>
        {onboardingProps?.description}
      </Typography>
      {onboardingProps?.actionEl && <Box>{onboardingProps.actionEl}</Box>}
    </Styled.Wrapper>
  );
});

TableOnboarding.displayName = 'TableOnboarding';
